<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('audit.systemLog.startDate')"
                            v-model="dti"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker
                            :label="$t('audit.systemLog.endDate')"
                            v-model="dtf"
                            :time-picker-props="timeProps"
                            :text-field-props="textFieldProps"
                            time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')"
                        >
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-select
                            v-model="filterLevel"
                            :items="levelOptions"
                            item-text="text"
                            item-value="value"
                            :label="$t('audit.systemLog.filters.level')"
                            multiple
                            clearable
                            chips
                            small-chips
                            deletable-chips
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="2">
                        <v-text-field
                            v-model="filterUser"
                            :label="$t('audit.systemLog.filters.user')"
                            clearable
                            prepend-inner-icon="mdi-account"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="2" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    :loading="loading"
                                    :disabled="!formValidado"
                                    @click="populaRelatorio"
                                    style="margin-bottom: 5px;"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    fab
                                    color="primary darken-1"
                                    class="white--text"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="setDefaultFilters"
                                    style="margin-left: 10px; margin-bottom: 5px;"
                                >
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="filterEvent"
                            :label="$t('audit.systemLog.filters.event')"
                            clearable
                            prepend-inner-icon="mdi-tag"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="filterOperation"
                            :label="$t('audit.systemLog.filters.operation')"
                            clearable
                            prepend-inner-icon="mdi-cog"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-text-field
                            v-model="filterSchema"
                            :label="$t('audit.systemLog.filters.schema')"
                            clearable
                            prepend-inner-icon="mdi-database"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" md="3" class="d-flex align-center">
                        <span class="text-caption grey--text">{{ $t('audit.systemLog.exportMultiDayHint') }}</span>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <merus-data-table
            :headers="headersWithProperties"
            :items="items"
            item-key="id"
            :loading="loading"
            sort-by="time"
            :sort-desc="true"
            dense
            class="elevation-7"
            locale="pt"
            :loading-text="$t('system.messages.loading')"
            style="border-radius: 10px; margin-top: 10px;"
        >
            <template v-slot:toolbar>
                <cadastro-toolbar
                    :title="$t('audit.systemLog.title')"
                    :token="token"
                    :items="items"
                    csv-title="auditoriasistema"
                    :pdf-title="$t('audit.systemLog.title')"
                    :pdf-headers="headers"
                    pdf-filename="auditoriasistema"
                    hide-search
                />
            </template>

            <template v-slot:item.level_extenso="{ item }">
                <v-chip
                    x-small
                    :color="levelColor(item.level)"
                    class="white--text"
                >
                    {{ item.level_extenso }}
                </v-chip>
            </template>

            <template v-slot:item.event_classification="{ item }">
                <v-chip
                    v-if="item.event_classification"
                    x-small
                    :color="classificationColor(item.event_classification)"
                    outlined
                >
                    {{ item.event_classification }}
                </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="blue" @click="openDetails(item)">
                    mdi-eye
                </v-icon>
            </template>
        </merus-data-table>

        <merus-data-table
            :headers="exportHeadersWithProperties"
            :items="exportItems"
            item-key="id_processo"
            :loading="loadingExports"
            sort-by="dt_requisicao"
            :sort-desc="true"
            dense
            class="elevation-7"
            locale="pt"
            :loading-text="$t('system.messages.loading')"
            style="border-radius: 10px; margin-top: 24px;"
        >
            <template v-slot:toolbar>
                <cadastro-toolbar
                    :title="$t('audit.systemLog.exportsTitle')"
                    :token="token"
                    :items="exportItems"
                    csv-title="exportslogsistema"
                    :pdf-title="$t('audit.systemLog.exportsTitle')"
                    :pdf-headers="exportHeaders"
                    pdf-filename="exportslogsistema"
                    hide-search
                />
            </template>

            <template v-slot:item.status_extenso="{ item }">
                <v-chip x-small :color="exportStatusColor(item.status)" class="white--text">
                    {{ item.status_extenso }}
                </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            class="mr-2"
                            :color="item.canDownload ? 'green darken-2' : 'grey'"
                            :disabled="!item.canDownload"
                            @click="downloadExport(item)"
                        >
                            mdi-download
                        </v-icon>
                    </template>
                    <span>{{ $t('audit.systemLog.download') }}</span>
                </v-tooltip>
            </template>
        </merus-data-table>

        <v-dialog v-model="dialogDetails" max-width="900">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="dialogDetails = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('audit.systemLog.detailsTitle') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pt-4">
                    <pre class="audit-log-details">{{ detailsFormatted }}</pre>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import DateUtils from '@/utils/dateutils';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import {
  addPendingSchedulerDownload,
  SCHEDULER_DOWNLOAD_TYPES,
} from '@/utils/schedulerDownloadPending';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
        user: null,
        token: null,
        dti: null,
        dtf: null,
        items: [],
        loading: false,
        formValidado: false,
        config: null,
        filterLevel: [],
        filterUser: null,
        filterEvent: null,
        filterOperation: null,
        filterSchema: null,
        dialogDetails: false,
        selectedEntry: null,
        exportItems: [],
        loadingExports: false,
        timeProps: {
            useSeconds: true,
        },
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.token = sessionStorage.getItem('api');
        this.initialize();
    },
    mounted() {
        EventBus.$on('system-log-export-updated', this.loadExports);
    },
    beforeDestroy() {
        EventBus.$off('system-log-export-updated', this.loadExports);
    },
    computed: {
        textFieldProps() {
            return {
                prependInnerIcon: 'mdi-calendar',
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        levelOptions() {
            return [
                { text: this.$t('audit.systemLog.levels.info'), value: 30 },
                { text: this.$t('audit.systemLog.levels.warn'), value: 40 },
                { text: this.$t('audit.systemLog.levels.error'), value: 50 },
            ];
        },
        headers() {
            return [
                { text: this.$t('audit.systemLog.headers.dateTime'), value: 'time_extenso' },
                { text: this.$t('audit.systemLog.headers.level'), value: 'level_extenso' },
                { text: this.$t('audit.systemLog.headers.event'), value: 'event_tag' },
                { text: this.$t('audit.systemLog.headers.classification'), value: 'event_classification' },
                { text: this.$t('audit.systemLog.headers.operation'), value: 'operation' },
                { text: this.$t('audit.systemLog.headers.schema'), value: 'schema' },
                { text: this.$t('audit.systemLog.headers.user'), value: 'user_login' },
                { text: this.$t('audit.systemLog.headers.message'), value: 'message' },
                { text: this.$t('audit.systemLog.headers.method'), value: 'req_method' },
                { text: this.$t('audit.systemLog.headers.url'), value: 'req_url' },
                { text: this.$t('audit.systemLog.headers.actions'), value: 'actions', sortable: false },
            ];
        },
        headersWithProperties() {
            return this.headers.map((header) => ({
                ...header,
                filtrable: header.value !== 'actions',
                sortable: header.value !== 'actions',
            }));
        },
        exportHeaders() {
            return [
                { text: this.$t('audit.systemLog.exportHeaders.requestedAt'), value: 'dt_requisicao_extenso' },
                { text: this.$t('audit.systemLog.exportHeaders.period'), value: 'period_extenso' },
                { text: this.$t('audit.systemLog.exportHeaders.status'), value: 'status_extenso' },
                { text: this.$t('audit.systemLog.exportHeaders.entries'), value: 'entriesReturned' },
                { text: this.$t('audit.systemLog.exportHeaders.file'), value: 'arquivo' },
                { text: this.$t('audit.systemLog.exportHeaders.actions'), value: 'actions', sortable: false },
            ];
        },
        exportHeadersWithProperties() {
            return this.exportHeaders.map((header) => ({
                ...header,
                filtrable: header.value !== 'actions',
                sortable: header.value !== 'actions',
            }));
        },
        detailsFormatted() {
            if (!this.selectedEntry) {
                return '';
            }
            return JSON.stringify(this.selectedEntry._raw || this.selectedEntry, null, 2);
        },
    },
    methods: {
        initialize() {
            this.getConfig();
            this.loadExports();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    this.setDefaultFilters();
                },
            });
        },
        setDefaultFilters() {
            if (this.config) {
                [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
            } else {
                const today = new Date();
                this.dti = today.toLocaleString().substring(0, 10) + ' 00:00:00';
                this.dtf = today.toLocaleString().substring(0, 10) + ' 23:59:59';
            }
            this.filterLevel = [];
            this.filterUser = null;
            this.filterEvent = null;
            this.filterOperation = null;
            this.filterSchema = null;
            this.items = [];
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        buildFilters() {
            const filters = {};
            if (this.filterLevel && this.filterLevel.length > 0) {
                filters.level = this.filterLevel;
            }
            if (this.filterUser) {
                filters.user = this.filterUser.trim();
            }
            if (this.filterEvent) {
                filters.event = this.filterEvent.trim();
            }
            if (this.filterOperation) {
                filters.operation = this.filterOperation.trim();
            }
            if (this.filterSchema) {
                filters.schema = this.filterSchema.trim();
            }
            return filters;
        },
        toIsoDate(value) {
            if (!value) return null;
            if (value instanceof Date) return value.toISOString();
            return value;
        },
        isMultiDayRange() {
            if (!this.dti || !this.dtf) {
                return false;
            }
            const horario =
                this.config && this.config.hora_inicial_dia_operacao
                    ? this.config.hora_inicial_dia_operacao
                    : null;
            if (horario) {
                const days = DateUtils.calculateReferenceDates(this.dti, this.dtf, horario);
                return days.length > 1;
            }
            const dtiMs = new Date(this.dti).getTime();
            const dtfMs = new Date(this.dtf).getTime();
            if (isNaN(dtiMs) || isNaN(dtfMs)) {
                return false;
            }
            return dtfMs - dtiMs > 24 * 60 * 60 * 1000;
        },
        populaRelatorio() {
            if (!this.$refs.form.validate()) {
                return;
            }

            if (this.isMultiDayRange()) {
                this.enqueueExport();
                return;
            }

            this.loading = true;
            apiController.request(apiController.endpoints.auditGetSystemlog, {
                data: {
                    dti: this.toIsoDate(this.dti),
                    dtf: this.toIsoDate(this.dtf),
                    filters: this.buildFilters(),
                },
                onSuccess: (response) => {
                    if (response.data.erro) {
                        EventBus.$emit('show-error', { error: response.data.mensagem });
                        this.items = [];
                    } else {
                        const logs = response.data.logs || [];
                        this.items = logs
                            .map((entry, index) => this.mapLogEntry(entry, index))
                            .sort((a, b) => (b.time || 0) - (a.time || 0));
                    }
                    this.loading = false;
                },
                onError: () => {
                    this.items = [];
                    this.loading = false;
                },
            });
        },
        enqueueExport() {
            const dti = this.toIsoDate(this.dti);
            const dtf = this.toIsoDate(this.dtf);

            apiController.request(apiController.endpoints.auditExportSystemlog, {
                data: {
                    dti,
                    dtf,
                    filters: this.buildFilters(),
                },
                onSuccess: (response) => {
                    if (response.data.erro || !response.data.id_processo) {
                        EventBus.$emit('show-alert', {
                            mensagem: response.data.mensagem || this.$t('audit.systemLog.exportFailed'),
                            tipo: 'error',
                        });
                        return;
                    }

                    addPendingSchedulerDownload({
                        id_processo: response.data.id_processo,
                        type: SCHEDULER_DOWNLOAD_TYPES.SYSTEM_LOG_EXPORT,
                        dti,
                        dtf,
                    });
                    EventBus.$emit('scheduler-download-enqueued');
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('audit.systemLog.exportEnqueued'),
                        tipo: 'info',
                        duracao: 6000,
                    });
                    this.loadExports();
                },
                onError: () => {
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('audit.systemLog.exportFailed'),
                        tipo: 'error',
                    });
                },
            });
        },
        loadExports() {
            this.loadingExports = true;
            apiController.request(apiController.endpoints.auditGetSystemlogExports, {
                data: {},
                silent: true,
                onSuccess: (response) => {
                    if (response.data.erro) {
                        this.exportItems = [];
                    } else {
                        this.exportItems = (response.data.exports || []).map((item) =>
                            this.mapExportItem(item)
                        );
                    }
                    this.loadingExports = false;
                },
                onError: () => {
                    this.exportItems = [];
                    this.loadingExports = false;
                },
            });
        },
        mapExportItem(item) {
            const statusKey = item.status || '';
            const statusExtenso =
                this.$t(`audit.systemLog.exportStatuses.${statusKey}`) || statusKey;
            let period = '';
            if (item.dti || item.dtf) {
                const dtiLabel = item.dti ? new Date(item.dti).toLocaleString().replace(',', '') : '';
                const dtfLabel = item.dtf ? new Date(item.dtf).toLocaleString().replace(',', '') : '';
                period = `${dtiLabel} — ${dtfLabel}`;
            }
            return {
                ...item,
                status_extenso: statusExtenso,
                period_extenso: period,
                entriesReturned: item.entriesReturned != null ? item.entriesReturned : '',
                arquivo: item.arquivo || '',
            };
        },
        exportStatusColor(status) {
            if (status === 'DONE') return 'green darken-2';
            if (status === 'FAILED' || status === 'CANCELED') return 'red darken-2';
            if (status === 'EXECUTING') return 'orange darken-2';
            return 'blue darken-2';
        },
        downloadExport(item) {
            if (!item || !item.canDownload || !item.id_processo) {
                return;
            }
            apiController.request(apiController.endpoints.auditDownloadSystemlogExport, {
                data: { id_processo: item.id_processo },
                config: { responseType: 'blob' },
                silent: true,
                onSuccess: async (response) => {
                    const disposition =
                        (response.headers && response.headers['content-disposition']) || '';
                    const ct = ((response.headers && response.headers['content-type']) || '')
                        .split(';')[0]
                        .trim()
                        .toLowerCase();
                    const isAttachment = /attachment/i.test(disposition);

                    if (!isAttachment && ct === 'application/json') {
                        try {
                            const text = await response.data.text();
                            const data = JSON.parse(text);
                            EventBus.$emit('show-alert', {
                                mensagem:
                                    data.mensagem || this.$t('audit.systemLog.exportDownloadError'),
                                tipo: 'error',
                            });
                        } catch (_err) {
                            EventBus.$emit('show-alert', {
                                mensagem: this.$t('audit.systemLog.exportDownloadError'),
                                tipo: 'error',
                            });
                        }
                        return;
                    }

                    const filename = item.arquivo || `systemlog-${item.id_processo}.csv`;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                },
                onError: () => {
                    EventBus.$emit('show-alert', {
                        mensagem: this.$t('audit.systemLog.exportDownloadError'),
                        tipo: 'error',
                    });
                },
            });
        },
        mapLogEntry(entry, index) {
            const eventTag = entry.event?.tag ?? (typeof entry.event === 'string' ? entry.event : '');
            const eventClass = entry.event?.classification ?? '';
            const user = entry.details?.user || {};
            const userLogin = user.login || entry.details?.username || '';
            const timeMs = typeof entry.time === 'number' ? entry.time : new Date(entry.time).getTime();
            const timeDate = isNaN(timeMs) ? null : new Date(timeMs);

            return {
                id: `${timeMs}-${index}`,
                time: timeMs,
                time_extenso: timeDate ? timeDate.toLocaleString().replace(',', '') : '',
                level: entry.level,
                level_extenso: this.levelLabel(entry.level),
                event_tag: eventTag,
                event_classification: eventClass,
                operation: entry.operation || '',
                schema: entry.schema || '',
                user_login: userLogin,
                message: entry.details?.message ?? '',
                req_method: entry.req?.method ?? '',
                req_url: entry.req?.url ?? '',
                _raw: entry,
            };
        },
        levelLabel(level) {
            const map = {
                10: this.$t('audit.systemLog.levels.trace'),
                20: this.$t('audit.systemLog.levels.debug'),
                30: this.$t('audit.systemLog.levels.info'),
                40: this.$t('audit.systemLog.levels.warn'),
                50: this.$t('audit.systemLog.levels.error'),
                60: this.$t('audit.systemLog.levels.fatal'),
            };
            return map[level] || String(level);
        },
        levelColor(level) {
            if (level >= 50) return 'red darken-2';
            if (level >= 40) return 'orange darken-2';
            return 'green darken-2';
        },
        classificationColor(classification) {
            const c = String(classification).toUpperCase();
            if (c === 'ERROR') return 'red';
            if (c === 'SUCCESS') return 'green';
            if (c === 'NEUTRAL') return 'grey';
            return 'blue';
        },
        openDetails(item) {
            this.selectedEntry = item;
            this.dialogDetails = true;
        },
    },
};
</script>

<style scoped>
.audit-log-details {
    max-height: 60vh;
    overflow: auto;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
    background: #f5f5f5;
    padding: 12px;
    border-radius: 4px;
}
</style>
